// const HOST = ''
export const WEP_URL_ORDERS = '/orders';

export const API_GET_ORDERS = '/orders/list';
export const API_CRUD_ORDER = '/orders';
export const API_ORDER_SIGN = '/orders/sign';
export const API_SEND_ORDER_REACTION = '/orders/reaction';

export const API_POST_SEND_QUESTION = '/send-question';

export const API_ORDER_SERVICES_LIST = '/api/services'
export const API_CITIES = '/api/cities'
export const API_GRAVEYARDS = '/api/graveyards'

export const API_TG_NUMBERS = '/api/tg/numbers'
